import type { IconDefinition } from '../index.tsx';

export const iconTransfer: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTransfer',
  icon: [
    16,
    16,
    [],
    '',
    'M10.2924 5.75002L11.7067 5.75002L15.9493 9.99266L11.7067 14.2353H10.2924V10.9927H8.0498V8.99266L10.2924 8.99266V5.75002Z M5.70666 10.2353L4.29245 10.2353L0.0498047 5.99264L4.29244 1.75L5.70666 1.75V4.99264L7.9493 4.99264V6.99264L5.70666 6.99264L5.70666 10.2353Z',
  ],
};
